export default class LocationConfigStorage {
    constructor() {
        this.locationConfig = null;
    }

    getLocationConfig() {
        return this.locationConfig;
    }

    setLocationConfig(locationConfig) {
        this.locationConfig = locationConfig;
    }
}

LocationConfigStorage.$inject = [];
